// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1DAZO","errors":"Errors_errors__1UH7r"};